"use strict";
/**
 * @author Tommy Brière
 * @copyright (c) 2015 Groupe PVP
 * @fileoverview Main configuration file
**/   
PVPGEngine.cfg = {
    width: 960,
    height: 540,
    fps: 30,
    minScale: 1,
    monoSound: false,//force monosound behavior
    nbCon: 4,
    innerControlsAtHeight: 600,
    prod: {/* config enabled after build script */
        showWarnings: false,
        showErrors: true,
        appBehavior: true
    },
    staging: {
        showWarnings: false,
        showErrors: true,
        appBehavior: true
    },
    dev: {/* config for local mode only */
        showWarnings: true,
        showErrors: true,
        appBehavior: true,//not used
        showFps: true,
        showBorders: true
    },
    test: {
        showWarnings: false,
        showErrors: false
    }
};